import State from "slotworks/state-machine/states/state";
import autoplayModel from "slotworks/model/autoplay-model";
import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";
import HidePromoFSonFreespins from "slotworks/commands/promo-free-spins/hide-pfs-on-freespins";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import Layers from "slotworks/graphics/layers/layers";
import Timer from "slotworks/utils/timer";
import CelebratePotsCommand from "commands/celebrate-pots-command";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";

export default class EnterRespins extends State {

    private static DELAY = 1500;

    public onEnter() {
        if (autoplayModel.stopOnFeatureWin) {
            StopAutoplayCommand();
        }
        CelebratePotsCommand().then(() => {
            smartButton.setFlag(SmartButtonFlag.PROMPT, true);
            Layers.SmartButton.hide();
            Layers.BetBar.hide();
            this.complete();
        });
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/enter-respins.ts